import React from 'react';

import { dggTheme } from '../../../../styles/dggTheme';
import { Content } from '../../molecules/Content/Content';
import * as styles from './TopGiftingTipsSection.styles';

export const TopGiftingTipsSection = () => {
  return (
    <div css={styles.root}>
      <Content backgroundColor={dggTheme.colors.moodyBlue}>
        <div css={styles.stepOneAndTwoContainer}>
          <div css={styles.stepOne}>
            <h4>Know your audience</h4>
            <p>
              Research shows the worst gifts are ones that don’t fit someone’s taste or interest.
              Gift better by showing that you know them. Or…
            </p>
          </div>
          <div css={styles.stepTwo}>
            <h4>Ask them</h4>
            <p>
              33% of people would rather you ask them what they’d like. It’s a good job we’ve got
              prezzies for literally everything – from beekeeping to baking.
            </p>
          </div>
          <div css={styles.redSpeechBubble}></div>
        </div>
        <div css={styles.stepThreeContainer}>
          <div css={styles.stepThree}>
            <h4>Don’t gift</h4>
            <p>
              Apparently, 84% of people feel obligated to give a gift – but only 26% of Brits say
              they expect a gift in return. In doubt? Don’t gift.
            </p>
          </div>
        </div>
        <h4 css={styles.spareTheirStorage}>
          Spare their storage, gift <em>so</em> them
        </h4>
        <div css={styles.makeItUseful}>
          <p>
            <strong>Tip: Make it useful</strong>
            <br />
            Think experience gifts, fave food and drink or something they’ve said they need or would
            use.
          </p>
        </div>
        <div css={styles.tailorIt}>
          <p>
            <strong>
              Tailor it to
              <br />
              their taste
            </strong>
            <br />
            Food or drink? Find something they *actually* like – and make it special.
          </p>
        </div>
        <p css={styles.wantToKnow}>
          Want to know what the most mis-gifted prezzies are? Course you do.
        </p>
      </Content>
    </div>
  );
};
